import * as React from 'react'
import { cn } from '@/lib/utils'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
<textarea
  data-slot='textarea'
  className={cn(
    // Base styles
    'flex field-sizing-content min-h-16 w-full rounded-md px-3 py-2 text-base md:text-sm',
    // Background and text
    'bg-surface text-foreground',
    // Border
    'border border-border',
    // Placeholder
    'placeholder:text-foreground/40',
    // Focus state
    'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-border focus-visible:border-border',
    // Invalid state
    'aria-invalid:border-red-500 aria-invalid:ring-1 aria-invalid:ring-red-500/20',
    // Disabled state
    'disabled:cursor-not-allowed disabled:opacity-50',
    // Smooth transitions
    'transition-all duration-200',
    className
  )}
  {...props}
/>
  )
}

export { Textarea }
